import axios from "axios";
import AuthService from "./auth.services";

const API_URL = "/api/v1/api-key/";

const getAccessToken = () => AuthService.getCurrentUser()?.accessToken || null;

const generateApiKey = (_, data) => {
    const accessToken = getAccessToken();
    if (!accessToken) return Promise.reject(new Error("Authentication required."));

    return axios.post(API_URL + "add", data, {
        headers: {
            Authorization: 'Bearer ' + accessToken,
        }
    });
};

const deleteApiKey = (params, _) => {
    const accessToken = getAccessToken();
    if (!accessToken) return Promise.reject(new Error("Authentication required."));

    return axios.delete(API_URL + "delete/" + params.api_key, {
        headers: {
            Authorization: 'Bearer ' + accessToken,
        }
    });
};

const getUserApiKeys = (params) => {
    const accessToken = getAccessToken();
    if (!accessToken) return Promise.reject(new Error("Authentication required."));

    return axios.get(API_URL + "get/" + params.user_id, {
        headers: {
            Authorization: 'Bearer ' + accessToken,
        }
    });
};

const ApiKeyServices = {
    generateApiKey,
    deleteApiKey,
    getUserApiKeys
}

export default ApiKeyServices;
